import { useQuery } from '@tanstack/react-query';

import { getRecipeCurationByName } from '../../../../api/recipe';
import { RecipeApi } from '../../../../api/recipe/recipe.api';
import { CurationType } from '../../../../type/recipe';
import { handleError } from '../../../../utils/common';
import { useAlertModal } from '../../../../utils/hook/hook';
import { useGetThisWeekVegetables } from '../../../../utils/hook/recipe';
import LoadingPage from '../../../LoadingPage';
import RecipeCurationSlide from '../components/RecipeCurationSlide';

const OriginalRecipeCuration = () => {
  const { openAlertModal } = useAlertModal();

  const { thisWeekVegetables } = useGetThisWeekVegetables();
  const { data: curation } = useQuery({
    queryKey: RecipeApi.queryKeys.curationByName(CurationType.UGLYUS),
    queryFn: () => getRecipeCurationByName(CurationType.UGLYUS),
    meta: {
      onError: (e: unknown) =>
        handleError(openAlertModal, e, '어글리어스 공식 레시피 가져오기'),
    },
    select: (curation) => ({
      ...curation,
      items: curation.items.slice(0, 6),
    }),
  });

  if (!curation) {
    return <LoadingPage />;
  }

  if (curation.totalCount === 0) return <></>;

  return (
    <RecipeCurationSlide
      title="어글리어스 공식 레시피"
      link={`/recipes/curation?type=${CurationType.UGLYUS}`}
      recipes={curation.items}
      thisWeekVegetables={thisWeekVegetables}
    />
  );
};

export default OriginalRecipeCuration;
